import { cloneDeep } from 'lodash';
import { conditionInit, defaultPageInfo } from '@/common/constants/ConstCode';

export default {
  initList: (state, flag = false) => {
    state.list = [];
    state.condition.page = 1;
    state.condition.userNo = '';
    state.condition.limit = 10;
    state.pageInfo.totalPage = 2;
    state.condition.searchText = '';
    state.condition.searchType = '';
    state.condition.searchFlag = flag;
    state.condition.familyCode = '';
  },
  // 컨디션(페이징) 객체들이 여러개이기 때문에 하나의 함수로 처리하기위함. condtionName에 해당하는 condition명만 넣어주면 모두 공백으로 초기화
  initCondition: (state, conditionName) => {
    for (let key in state[conditionName]) {
      if (typeof state[conditionName][key] === 'boolean') state[conditionName][key] = false;
      if (typeof state[conditionName][key] === 'object') state[conditionName][key] = null;
      else state[conditionName][key] = '';
    }
    state[conditionName].page = 1;
    state[conditionName].limit = 10;
  },
  setList: (state, list) => {
    state.list = [...state.list, ...list];
  },
  setAliveDetail: (state, data) => {
    Object.assign(state.aliveDetail, data);
  },
  setAliveList: (state, list) => {
    state.aliveList = [...list] || [];
  },
  setCondition: (state, data) => {
    Object.assign(state.condition, data);
  },
  setPageInfo: (state, info) => {
    state.pageInfo = info;
  },

  setPage(state, page) {
    state.condition.page = page;
  },
  detailInit: (state, dataKey) => {
    for (let key in state[dataKey]) {
      state[dataKey][key] = '';
    }
  },
  setDetail: (state, data) => {
    Object.assign(state.detail, data);
  },
  setBackground: (state, data) => {
    state.backgroundList = data;
  },
  setFrame: (state, data) => {
    state.frameList = data;
  },

  initAllStep: state => {
    state.register.step1 = [
      {
        imageFile: [],
        deadName: '',
        family: [
          {
            relation: '선택',
            name: ''
          }
        ],
        birthDate: '',
        deathDate: '',
        churchNo: '',
        churchJob: '',
        churchText: '',
        preViewImage: ''
      },
      {
        imageFile: [],
        deadName: '',
        family: [
          {
            relation: '선택',
            name: ''
          }
        ],
        birthDate: '',
        deathDate: '',
        churchNo: '',
        churchJob: '',
        churchText: '',
        preViewImage: ''
      }
    ];
    state.register.step2 = [];
    state.register.step3 = {};
  },

  // Form
  setStep1: (state, data) => {
    state.register.step1 = cloneDeep(data);
    for (let i = 0; i < state.register.step1.length; i++) {
      state.register.step1[i].family = JSON.stringify(state.register.step1[i].family);
      if (state.register.step1[i]?.imageFile[0]?.hasOwnProperty('storedFileName')) {
        state.register.step1[i].deadImageInfo = state.register.step1[i]?.imageFile[0];
      } else {
        state.register.step1[i].deadImageRaw = state.register.step1[i]?.imageFile[0];
      }
    }
  },

  // Alert
  setStep2: (state, data) => {
    state.register.step2 = cloneDeep(data);
  },

  setCommentList: (state, list) => {
    state.commentList = [...list, ...state.commentList];
  },

  appendComment: (state, comment) => {
    state.commentList = [...state.commentList, comment];
  },

  setCommentPage: (state, page) => {
    state.commentCondition.page = page;
  },

  initComment: state => {
    state.commentList = [];
    state.commentCondition = { page: 1, limit: 10, andersenNo: '' };
    state.pageInfo = defaultPageInfo;
  },

  setAnniversaryList: (state, list) => {
    state.anniversaryList = list;
  }
};
